var React = require('react');

var Loading = React.createClass({
    propTypes: {
        message: React.PropTypes.string
    },
    getDefaultProps: function () {
        return {
            message: 'Loading ...'
        }
    },
    render: function () {
        return <span>
            <i className="fa fa-spinner fa-pulse"></i>&nbsp;{this.props.message}
        </span>;
    }
})
module.exports = Loading;



// WEBPACK FOOTER //
// ./app/components/Loading.js